<template>
	<div>
		<alert-success :form="form" message="User attached to company successfully." />
		<alert-error :form="form" message="User could not be attached to company." />
		<div class="d-flex justify-content-center">
			<div class="wd-500 card shadow-sm">
				<div class="card-header">
					<h3 class="df-title">Attach User To Company</h3>
				</div>
				<div class="card-body">
					<form @submit.prevent="attachUser">
						<div class="form-group">
							<label>Company</label>
							<select v-model="company" id="company" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('company') }" required>
								<option :value="null" disabled>Select company</option>
							</select>
							<has-error :form="form" field="company"></has-error>
						</div>
						<div class="form-group">
							<label>User</label>
							<select v-model="form.user" id="user" class="custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('user') }" required>
								<option :value="null" disabled>Select user</option>
							</select>
							<has-error :form="form" field="user"></has-error>
						</div>

						<button-component :busy="form.busy" :label="'Attach User'" :label-loading="'Attaching user...'"><em class="fas fa-link"></em> </button-component>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	mounted() {
		const { company_name, id } = this.$route.params;

		$('#company')
			.select2({
				placeholder: 'Select company',
				allowClear: true,
				ajax: {
					url: '/api/companies',
					dataType: 'json',
					headers: {
						Authorization: `Bearer ${localStorage.token}`,
					},
					data: function ({ term }) {
						return {
							filter: term,
						};
					},
					processResults: function ({ data: { companies } }) {
						const results = _.map(companies, (company) => ({
							id: company.external_client_id,
							text: `${company.name} (${company.external_client_id})`,
						}));

						return {
							results,
						};
					},
				},
			})
			.on('select2:select', (event) => {
				this.company = event.params.data.id;
			})
			.on('select2:unselect', (event) => {
				this.company = null;
			});

		if (company_name) {
			const option = new Option(company_name, id, false, true);
			$('#company').append(option).trigger('change');

			$('#company').trigger({
				type: 'select2:select',
				params: {
					data: {
						id,
						text: company_name,
					},
				},
			});
		}
		$('#user').select2({
			placeholder: 'Select user',
			allowClear: true,
			ajax: {
				url: '/api/company-users',
				dataType: 'json',
				headers: {
					Authorization: `Bearer ${localStorage.token}`,
				},
				data: function ({ term }) {
					return {
						filter: term,
					};
				},
				processResults: function ({ data: { company_users } }) {
					const results = _.map(company_users, (user) => ({
						id: user.id,
						text: `${user.fullname} (${user.email})`,
					}));

					return {
						results,
					};
				},
			},
		});

		$('#user').on('select2:select', (event) => {
			this.form.user = event.params.data.id;
		});
		$('#user').on('select2:unselect', (event) => {
			this.form.user = null;
		});
	},
	data() {
		return {
			company: null,
			form: new Form({
				user: null,
			}),
		};
	},
	methods: {
		attachUser() {
			if (this.company) {
				this.form
					.post(`/api/companies/${this.company}/attach-user`)
					.then(() => {
						$('#company').val(null).trigger('change');
						$('#user').val(null).trigger('change');
						this.company = null;
						this.form.user = null;
					})
					.catch(({ response }) => console.log(response));
			}
		},
	},
};
</script>
